import { useTranslation } from "react-i18next"
import GoalbankSelectionTemplate from "../common/GoalbankSelectionTemplate"
import { translateGradeLevel } from "utils/helpers"
import { useGET_setupOptionsQuery } from "redux/api/setupApi"

const SyllabusTemplate = ({ entity }) => {

  const { t } = useTranslation()

  const { data: setupData } = useGET_setupOptionsQuery()
  
  return (
    setupData && <> 
                  <div style={{ fontWeight: 'bold' }} className="border-grid-td">
                    <span>{ entity.course?.subject?.title }</span> / 
                    <span style={{marginLeft: '5px'}}>{ entity.course?.domain?.title }</span> / 
                    <span style={{marginLeft: '5px',textTransform: 'uppercase'}}>
                      {translateGradeLevel(entity.course?.grade_level, true)}.{entity.course?.term}.{entity.course?.course_code}</span>
                    {/* <br /> { entity.title } */}
                  </div>


                  {(entity.goalbank_selection || entity.curriculum_selection) &&  setupData.filter(sd => sd.slug == "syllabus_curriculum" && sd.is_enabled).length == 1 && 
                    <GoalbankSelectionTemplate goalbankSelection={entity.goalbank_selection} curriculumSelection={entity.curriculum_selection}/>
                  }

                 {setupData.filter(sd => sd.slug == "syllabus_course" && sd.is_enabled).length == 1 &&  <>

                    {setupData.filter(sd => sd.slug == "syllabus_contact_information" && sd.is_enabled).length == 1 && 
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{ t('syllabuses.contact-information') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.contact_information }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_course_description" && sd.is_enabled).length == 1 && 
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.course-description') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.course_description }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "" && sd.is_enabled).length == 1 && 
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.course-prerequisites') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.course_prerequisites }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "" && sd.is_enabled).length == 1 && 
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>  
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.course-instructions') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.course_instructions }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "" && sd.is_enabled).length == 1 &&  
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.course-materials') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity. course_materials }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "" && sd.is_enabled).length == 1 && 
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.student-participation') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.student_participation }} />
                    </div>}

                  </>}


                  {setupData.filter(sd => sd.slug == "syllabus_course_policy" && sd.is_enabled).length == 1 &&  <>

                    {setupData.filter(sd => sd.slug == "syllabus_homework_policy" && sd.is_enabled).length == 1 && 
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.homework-policy') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.homework_policy }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_tutorial_policy" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.tutorial-policy') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.tutorial_policy }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_absentee_policy" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>  
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.absentee-policy') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.absentee_policy }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_tardy_policy" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.tardy-policy') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.tardy_policy  }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_late_work_procedures" && sd.is_enabled).length == 1 &&  
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.late-work-procedures') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.late_work_procedures }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_absence_procedures" && sd.is_enabled).length == 1 &&  
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.absence-procedures') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.absence_procedures }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_assignment_policy" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.assignment-policy') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.assignment_policy }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_turning_in_assignment" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.turning-in-assignment') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.turning_in_assignment }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_retake_policy" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.retake-policy') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.retake_policy }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_assessment_type" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.assessment-type') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.assessment_type }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_assessment_corrections" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.assessment-corrections') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.assessment_corrections }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_grading_policy" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.grading-policy') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.grading_policy  }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_grading_breakdown" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.grading-breakdown') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.grading_breakdown }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_extra_credits" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.extra-credits') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.extra_credits  }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_behaviour_expectations" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.behaviour-expectations') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.behaviour_expectations }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_consequences" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.consequences') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.consequences }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_bullying_prevention" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.bullying-prevention') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.bullying_prevention }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_student_responsibilities" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('syllabuses.student-responsibilities') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.student_responsibilities }} />
                    </div>}  
                  
                    {setupData.filter(sd => sd.slug == "syllabus_classroom_rules" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{ t('syllabuses.classroom-rules') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.classroom_rules  }} />
                    </div>}

                    {setupData.filter(sd => sd.slug == "syllabus_penalties" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{ t('syllabuses.penalties') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.penalties }} />
                    </div>}
                  
                    {setupData.filter(sd => sd.slug == "syllabus_plagiarism" && sd.is_enabled).length == 1 &&
                    <div className="border-grid-td" style={{ marginTop: '10px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{ t('syllabuses.plagiarism') }</div>
                      <div dangerouslySetInnerHTML={{ __html: entity.plagiarism  }} />
                    </div>}

                  </>}


                  <div className="border-grid-td" style={{ marginTop: '10px' }}> 
                    <div style={{ fontWeight: 'bold' }}>{ t('syllabuses.academic-expectations') }</div>
                    <div>{
                        entity.syllabus_expectations.map(e => <div key={e.id} style={{marginTop: '10px'}}>
                          {e.title}: 
                          <span><b>{e.amount}</b> <b>{e.amount_choice}</b> / </span>
                          <b>{e.frequency}</b> <b>{e.frequency_choice}</b>
                        
                        </div>)
                      }</div>
                  </div>

                  <div className="border-grid-td" style={{ marginTop: '10px' }}>
                    <div style={{ fontWeight: 'bold' }}>{ t('syllabuses.grading-plan') }</div>
                    <div>{
                        entity.syllabus_components.map(c => 
                          <div key={c.id} style={{marginTop: '10px'}}>{ c.title}: <b>{c.importance}%</b></div>)
                      }</div>
                  </div>

                  
    </>
  )
}

export default SyllabusTemplate
